import { IComponentSpecElevation } from 'types/api';

export const addSystemPower = (elevation: IComponentSpecElevation) =>
  elevation.systems.reduce(
    (prev, curr) => {
      return { system_power: prev.system_power + curr.system_power };
    },
    { system_power: 0 }
  );
